import { Button, ButtonLink, Icon, RatingStars } from '@/components/ui';
import React, { useState } from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { Link } from 'react-router-dom';
import useLadyService from '@/services/LadyService';

import { useTranslation } from 'react-i18next';
import './agencyCard.scss';

const AgencyCard = ({ clazz = '', buttonColor = 'button--primary', props }) => {
	const {
		id,
		name,
		address: addressData,
		rating,
		phone,
		description,
		whatsapp,
		telegram,
		logo,
		image,
		profiles,
		is_massage,
	} = props;

	const { address = null } = addressData || {};

	const { lang, setMediaSize } = useLadyService();

	const [clicked, setClicked] = useState(false);

	const { t } = useTranslation('translation');

	let postAltAgency = t('altagency', { AgencyName: name });

	if (is_massage) {
		postAltAgency = t('altstudio', { AgencyName: name });
	}

	const phoneRes = !!formatPhoneNumberIntl(`${phone}`)
		? formatPhoneNumberIntl(`${phone}`)
		: formatPhoneNumberIntl(`+${phone}`);

	return (
		<div className={`agency-card ${clazz}`}>
			<Link
				to={`/${lang}/agency/${id}`}
				title={postAltAgency}
				className="agency-card__img"
			>
				<img
					loading="eager"
					fetchpriority="high"
					src={setMediaSize(image ?? logo, 'm')}
					alt={postAltAgency}
				/>
			</Link>
			<div className="agency-card__content">
				<div className="agency-card__heading">
					<Link to={`/${lang}/agency/${id}`}>
						<h3 className={'mt-0 mb-0 title_h2'}>{name}</h3>
					</Link>
					{!!address || !!rating ? (
						<div>
							{!!address && (
								<Link
									to={`https://www.google.com/maps/search/${address}`}
									target="__blank"
									className="agency-card__address"
								>
									<Icon spritePath={'map-pin'} /> {address}
								</Link>
							)}

							{!!rating ? (
								<RatingStars
									value={rating}
									readOnly={true}
								/>
							) : null}
						</div>
					) : null}
				</div>

				{!!Object.values(profiles).length ? (
					<div className="agency-card__counts">
						{!!profiles?.total ? (
							<div className={'agency-card__count'}>
								<Icon
									size={'l'}
									spritePath={'body2'}
								/>
								<div className="agency-card__questionnaires">
									<span>
										{t('profiles').charAt(0).toUpperCase() +
											t('profiles').slice(1)}
									</span>
									{profiles.total}
								</div>
							</div>
						) : null}

						{!!profiles?.verified ? (
							<div className={'agency-card__count'}>
								<Icon
									size={'l'}
									spritePath={'verify'}
								/>
								<div className="agency-card__verified">
									<span>{t('verified')}</span>
									{profiles.verified}
								</div>
							</div>
						) : null}

						{!!profiles?.online ? (
							<div className={'agency-card__count'}>
								<Icon
									size={'l'}
									spritePath={'status'}
								/>
								<div className="agency-card__online">
									<span>{t('online')}</span>
									{profiles.online}
								</div>
							</div>
						) : null}
					</div>
				) : null}

				{!!description && <p>{description}</p>}

				<div className="agency-card__buttons">
					{clicked ? (
						<ButtonLink
							href={`tel:+${phone}`}
							size={'m'}
							clazz={`${buttonColor} justify-center w-100`}
						>
							{phoneRes}
						</ButtonLink>
					) : (
						<Button
							onClick={() => setClicked(true)}
							clazz={`${buttonColor} w-100`}
							size={`m`}
						>
							{t('shownumber')}
						</Button>
					)}
					{!!whatsapp ? (
						<ButtonLink
							href={`https://wa.me/${whatsapp}`}
							target="_blank"
							clazz={`${buttonColor} button-icon`}
							size={'m'}
							title={'Whatsapp'}
						>
							<Icon
								size={'xl'}
								spritePath={'whatsapp'}
							/>
						</ButtonLink>
					) : null}

					{!!telegram ? (
						<ButtonLink
							href={`https://t.me/${telegram}`}
							target="_blank"
							title={'Telegram'}
							clazz={`${buttonColor} button-icon`}
							size={'m'}
						>
							<Icon
								size={'xl'}
								spritePath={'telegram'}
							/>
						</ButtonLink>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default AgencyCard;
